export default __webpack_public_path__ + "static/wave-thumb-1400-27585d66d81f0ae87971d35132def286.jpg";